import { NAV_HEIGHT, SHOWCASE_NAV_HEIGHT } from '../../constants';

export const GRID_LAYOUT_NAMES = {
  STACKED: 'STACKED',
  SIDE_BY_SIDE: 'SIDE_BY_SIDE',
  SIDE_BY_SIDE_WITH_SIDE_MODULE: 'SIDE_BY_SIDE_WITH_SIDE_MODULE',
  MOBILE: 'MOBILE',
};

/**
 * Grid template areas change based on whether comments or the playlist are going to be present in the UI
 * If modules are not going to be present we can't define the grid area otherwise grid spacing will be applied to empty cells
 * */
export const createGridTemplateAreasConfig = (showComments: boolean, showPlaylist: boolean) => ({
  [GRID_LAYOUT_NAMES.STACKED]: `
    "media media media media media media"
    ${
      showComments
        ? '"contentStack contentStack contentStack contentStack comments comments"'
        : '"contentStack contentStack contentStack contentStack contentStack contentStack"'
    }
    ${
      showPlaylist
        ? `"playlist playlist playlist playlist ${
            showComments ? 'comments comments' : 'playlist playlist'
          }"`
        : ''
    }
  `,
  [GRID_LAYOUT_NAMES.SIDE_BY_SIDE]: `
    "media media media media comments comments"
    "contentStack contentStack contentStack contentStack comments comments"
    ${showPlaylist ? '"playlist playlist playlist playlist comments comments"' : ''}
  `,
  [GRID_LAYOUT_NAMES.SIDE_BY_SIDE_WITH_SIDE_MODULE]: `
    "media media media media sideModule sideModule"
    "contentStack contentStack contentStack contentStack sideModule sideModule"
    ${showComments ? '"comments comments comments comments sideModule sideModule"' : ''}
    ${showPlaylist ? '"playlist playlist playlist playlist sideModule sideModule"' : ''}
  `,
  [GRID_LAYOUT_NAMES.MOBILE]: `
    "media"
    "contentStack"
    ${showPlaylist ? '"playlist"' : ''}
  `,
});

export const GRID_TEMPLATE_AREAS_LOADER = `
  "media media media media media media"
  "contentStack contentStack contentStack contentStack contentStack contentStack"
`;

export const createShowcaseGridTemplateAreasConfig = (
  isShowcaseClipView: boolean,
  isLiveEventOrCommentsView: boolean,
  showComments: boolean = false,
) => ({
  [GRID_LAYOUT_NAMES.STACKED]: `
    "media media media media media media" 
    ${
      isShowcaseClipView && !isLiveEventOrCommentsView
        ? '"contentStack contentStack contentStack contentStack contentStack contentStack"'
        : ''
    }
    ${
      isShowcaseClipView && isLiveEventOrCommentsView
        ? '"contentStack contentStack contentStack contentStack comments comments"'
        : ''
    }
    ${
      isLiveEventOrCommentsView
        ? '"playlist playlist playlist playlist comments comments"'
        : '"playlist playlist playlist playlist playlist playlist"'
    }
    
  `,
  [GRID_LAYOUT_NAMES.SIDE_BY_SIDE]: `
    "media media media media comments comments"
    "contentStack contentStack contentStack contentStack comments comments"
    "playlist playlist playlist playlist comments comments"
  `,
  [GRID_LAYOUT_NAMES.SIDE_BY_SIDE_WITH_SIDE_MODULE]: `
    "media media media media sideModule sideModule"
    "contentStack contentStack contentStack contentStack sideModule sideModule"
    ${showComments ? '"comments comments comments comments sideModule sideModule"' : ''}
    "playlist playlist playlist playlist sideModule sideModule"
  `,
  [GRID_LAYOUT_NAMES.MOBILE]: `
    "media"
    ${isShowcaseClipView ? '"contentStack"' : ''}
    "playlist"
  `,
});

export const returnActiveGridTemplateName = (
  isSideModuleOpen: boolean,
  isSideBySideActive: boolean,
) => {
  const sideBySideGrid = isSideModuleOpen
    ? GRID_LAYOUT_NAMES.SIDE_BY_SIDE_WITH_SIDE_MODULE
    : GRID_LAYOUT_NAMES.SIDE_BY_SIDE;

  return isSideBySideActive ? sideBySideGrid : GRID_LAYOUT_NAMES.STACKED;
};

export const getAsideHeightStyles = (
  space200: string,
  space300: string,
  globalNavigationHidden: boolean | undefined,
  isShowcaseLayout: boolean | undefined,
) => {
  const headerPosition = globalNavigationHidden ? 0 : NAV_HEIGHT;

  if (isShowcaseLayout) {
    return {
      base: '100%',
      md: `calc(100vh - ${headerPosition}px - ${space200} - ${SHOWCASE_NAV_HEIGHT}px)`,
      lg: `calc(100vh - ${headerPosition}px - ${space300} - ${SHOWCASE_NAV_HEIGHT}px)`,
    };
  }

  return {
    base: '100%',
    md: `calc(100vh - ${headerPosition}px - ${space200} - ${space200})`,
    lg: `calc(100vh - ${headerPosition}px - ${space300} - ${space300})`,
  };
};

export const getAsideTopStyles = (
  space200: string,
  space300: string,
  globalNavigationHidden: boolean | undefined,
) => {
  const headerPosition = globalNavigationHidden ? 0 : NAV_HEIGHT;

  return {
    base: `calc(${headerPosition}px + ${space200})`,
    lg: `calc(${headerPosition}px + ${space300})`,
  };
};
